import { ArrowRightIcon } from '../components/icons/ArrowRightIcon';
import { ToastOutlet } from '../components/ToastOutlet';
import classNames from '../helper/classNames';
import { MobileWelcomeDemoVideo } from './Welcome/WelcomeDemoVideo';
import { MobileWelcomeSpeakerProfile } from './Welcome/WelcomeSpeakerProfile';
import { MobileWelcomeUserProfile } from './Welcome/WelcomeUserProfile';
import { MobileWelcomeVideoScript } from './Welcome/WelcomeVideoScript';
import { MobileWelcomeVideoTitle } from './Welcome/WelcomeVideoTitle';

const checkpointNames = {
  SETUP_PROFILE: 'SETUP_PROFILE',
  DEMO_VIDEO: 'DEMO_VIDEO',
  CREATE_VIDEO_TITLE: 'CREATE_VIDEO_TITLE',
  CREATE_VIDEO_SCRIPT: 'CREATE_VIDEO_SCRIPT',
};

export const MobileSoloWelcome = ({
  checkpoint,
  checkpointsData,
  isAtCheckpoint,
  nextButtonStyling,
  previousButtonStyling,
  handleNextClick,
  handlePreviousClick,
  videoTitle,
  setVideoTitle,
  videoScript,
  setVideoScript,
  speaker,
  setSpeaker,
  workspaceId,
}) => {
  const [SETUP_PROFILE, DEMO_VIDEO, CREATE_VIDEO_TITLE, CREATE_VIDEO_SCRIPT] = [
    checkpointsData[checkpointNames.SETUP_PROFILE],
    checkpointsData[checkpointNames.DEMO_VIDEO],
    checkpointsData[checkpointNames.CREATE_VIDEO_TITLE],
    checkpointsData[checkpointNames.CREATE_VIDEO_SCRIPT],
  ];
  return (
    <div
      className="w-full h-[100dvh] pb-[29px] flex justify-center"
      style={{
        background:
          'linear-gradient(180deg, #FFDDC2 0%, rgba(255, 221, 194, 0.00) 100%)',
      }}
    >
      <ToastOutlet />
      <div className="flex flex-col justify-between w-full max-w-[432px] gap-6">
        <div className="flex flex-col grow w-full items-center pt-[10%] tall:pt-[125px]">
          <span className="w-full text-center font-roboto font-extrabold text-black text-2xl">
            {checkpoint?.topics[0]}
          </span>
          <span className="w-full text-center font-roboto text-base text-[#3B3B3B]">
            {checkpoint?.topics[1]}
          </span>
          <div className="flex gap-5 px-[53px] h-fit w-full">
            {Object.keys(checkpointsData).map((checkpoint, currentIdx) => (
              <div
                key={currentIdx}
                className="flex flex-col gap-1 items-center flex-1 mt-8"
              >
                <div
                  className={classNames(
                    'w-full h-[10px] rounded-lg',
                    isAtCheckpoint(checkpoint) ? 'bg-purple' : 'bg-[#252525]'
                  )}
                ></div>
                <div
                  className={classNames(
                    'text-xxs text-center font-medium',
                    isAtCheckpoint(checkpoint)
                      ? 'text-purple'
                      : 'text-[#252525]'
                  )}
                >
                  {checkpointsData[checkpoint].heading}
                </div>
              </div>
            ))}
          </div>
          {checkpoint === SETUP_PROFILE && (
            <>
              {speaker ? (
                <MobileWelcomeSpeakerProfile
                  speaker={speaker}
                  setSpeaker={setSpeaker}
                />
              ) : (
                <MobileWelcomeUserProfile workspaceId={workspaceId} />
              )}
            </>
          )}
          {checkpoint === DEMO_VIDEO && <MobileWelcomeDemoVideo />}
          {checkpoint === CREATE_VIDEO_TITLE && (
            <MobileWelcomeVideoTitle
              videoTitle={videoTitle}
              setVideoTitle={setVideoTitle}
            />
          )}
          {checkpoint === CREATE_VIDEO_SCRIPT && (
            <MobileWelcomeVideoScript
              videoScript={videoScript}
              setVideoScript={setVideoScript}
            />
          )}
        </div>
        <div className="flex justify-between w-full px-[26px] h-[65px]">
          <button
            className={classNames(
              'h-[65px] w-[65px] flex items-center justify-center rounded-2xl',
              previousButtonStyling
            )}
            onClick={() => handlePreviousClick()}
          >
            <ArrowRightIcon className="fill-white rotate-180" />
          </button>
          <button
            className={classNames(
              'h-[65px] w-[65px] flex items-center justify-center rounded-2xl',
              nextButtonStyling
            )}
            onClick={() => handleNextClick()}
          >
            <ArrowRightIcon className="fill-white" />
          </button>
        </div>
      </div>
    </div>
  );
};
